export { default } from "./configure.web";
